export const ITEM_TYPES = Object.freeze({
  CHOICE: 'choice',
  BOOLEAN: 'boolean',
  TEXT: 'text',
  INTEGER: 'integer',
  RADIO: 'choice-radio',
});

export const ITEM_TYPES_ARRAY = Object.values(ITEM_TYPES);
